module.exports = __webpack_public_path__ + "images/img-35jxgT5.jpg";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/dashboard/year-results/en/income.jpg
// module id = 1995
// module chunks = 0